module.exports = __webpack_public_path__ + "img/street1.jpg";